module.exports = __webpack_public_path__ + "img/symbol_9.d4838eb8.png";